import { withDependencies } from '@wix/thunderbolt-ioc'
import { IPropsStore, Props } from '@wix/thunderbolt-symbols'
import type { IModelUpdatesHandlersImplementor } from 'ds-feature-model-updates-invoker'
import type { OOIHandlers } from '../types'
import { name } from '../symbols'

export const ooiWidgetSideEffectsHandler = withDependencies(
	[Props],
	(propsStore: IPropsStore): IModelUpdatesHandlersImplementor<OOIHandlers> => ({
		featureName: name,
		handlers: {
			onOoiWidgetDimensionsUpdate({ dimensions, ooiWidgetId }) {
				const currentDimensions = propsStore.get(ooiWidgetId)?.host?.dimensions
				if (!currentDimensions) {
					return
				}

				propsStore.update({
					[ooiWidgetId]: {
						host: {
							...propsStore.get(ooiWidgetId)!.host,
							dimensions,
						},
					},
				})
			},
			onOoiWidgetStyleUpdate({ style: { style: styleParams, siteColors, siteTextPresets }, ooiWidgetId }) {
				const currentStyleProps = propsStore.get(ooiWidgetId)?.host?.style
				if (!currentStyleProps) {
					return
				}

				propsStore.update({
					[ooiWidgetId]: {
						host: {
							...propsStore.get(ooiWidgetId)!.host,
							style: { ...currentStyleProps, styleParams, siteColors, siteTextPresets },
						},
					},
				})
			},
			onOoiFormFactorUpdate({ formFactor, ooiWidgetId }) {
				const currentFormFactorProp = propsStore.get(ooiWidgetId)?.host?.formFactor
				if (!currentFormFactorProp) {
					return
				}

				propsStore.update({
					[ooiWidgetId]: {
						host: {
							...propsStore.get(ooiWidgetId)!.host,
							formFactor,
						},
					},
				})
			},
		},
	})
)
